import floatField from "./float";

export default {
  float: floatField,
};
